import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Paper,
  CircularProgress,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  TrendingUp,
  Assignment,
  People,
  CheckCircle,
  Pending,
  Cancel,
  Refresh,
} from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer, BarChart, Bar, PieChart, Pie, Cell } from 'recharts';

import { applicationService } from '../../services/applicationService';
import RoleBasedDashboard from '../../components/Dashboard/RoleBasedDashboard';

const Dashboard = () => {
  const { role } = useSelector((state) => state.auth);
  
  // If user has a specific role, show role-based dashboard
  if (role?.name && ['admin', 'l1_staff', 'citizen', 'dc', 'sdm', 'dpo', 'reve_o', 'ahvs_h', 'agri_h', 'horti_h', 'reve_i', 'ahvs_i', 'agri_i', 'horti_i', 'accounts'].includes(role.name)) {
    return <RoleBasedDashboard />;
  }

  // Fallback to general dashboard for unknown roles or legacy users
  const [timeRange, setTimeRange] = useState('30'); // days

  // Fetch dashboard statistics
  const { data: stats, isLoading: statsLoading, refetch: refetchStats } = useQuery({
    queryKey: ['dashboard-stats', timeRange],
    queryFn: () => applicationService.getApplicationStats({ days: timeRange }),
    refetchInterval: 5 * 60 * 1000, // Refetch every 5 minutes
  });

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4" fontWeight="bold">
          Dashboard
        </Typography>
        <Tooltip title="Refresh Data">
          <IconButton onClick={refetchStats}>
            <Refresh />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default Dashboard;
